var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaBrandsTelegramPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9594 3.08125L11.8469 13.0437C11.6875 13.7469 11.2719 13.9219 10.6813 13.5906L7.4625 11.2188L5.90938 12.7125C5.7375 12.8844 5.59375 13.0281 5.2625 13.0281L5.49375 9.75L11.4594 4.35938C11.7188 4.12813 11.4031 4 11.0563 4.23125L3.68125 8.875L0.506251 7.88125C-0.184374 7.66563 -0.196874 7.19063 0.650001 6.85938L13.0688 2.075C13.6438 1.85938 14.1469 2.20313 13.9594 3.08125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaBrandsTelegramPlane);
export default __webpack_public_path__ + "static/media/fa-brands_telegram-plane.14bb3bf449fec7395ace45c21b7d1e83.svg";
export { ForwardRef as ReactComponent };